import axios from 'axios'
import apiConfig from '../../config/apiConfig'
import { buildURL } from '../helper'
import { getBpIdParam } from '../../common/helper'
import { trackFeatureAction } from '../../common/otel'

const saveFeedback = async (requestObject: any) => {
  const bpIdParam = getBpIdParam()
  trackFeatureAction('feedback_save', 'attempt')
  try {
    const { status } = await axios.post(
      `${buildURL('feedback', apiConfig.feedback)}${bpIdParam}`,
      requestObject,
    )
    trackFeatureAction('feedback_save', 'success')
    return status
  } catch (error) {
    trackFeatureAction('feedback_save', 'error')
    throw error
  }
}

export default saveFeedback
